import { FC, useEffect, useState, useContext, createContext } from "react";
import { isLoggedIn, saveToken } from "../services/CookieHandler";
import { LoginDialog } from "./LoginDialog";
import { Container, Group, Burger, Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import classes from '../HeaderSimple.module.css'
import { create } from 'zustand'
import { fetchAsync } from "../services/ApiHandler";
import { RemainCountResponse } from "../model/RemainCountResponse";
import { Subscription } from "../model/Subscription";
import { getNextPlanId, getPlanName, getPlanNameBySubscription } from "../services/SubscriptionService";
import { StripeCard } from "../model/StripeCard";
import { SetupIntentResponse } from "../model/SetupIntentResponse";
import { Account } from "../model/Account";
import { removeToken } from "../services/CookieHandler";
import { SubscriptionDialog, SubscriptionDialogProps } from "./SubscriptionDialog";
import { GenerationCreditDialog, GenerationCreditDialogProps } from "./GenerationCreditDialog";
import { toast, Toaster } from "react-hot-toast";
import { CardRegistrationDialog } from "./CardRegisterDialog";
import { CardRegistrationDialogProps } from "./CardRegisterDialog";
import { ProfileImage } from "../model/ProfileImage";
import { getProfileImageUrl } from "../services/ProfileImageUtil";
import { getSkyFlagUrl } from "../services/SkyFlagUtil";
import { useLocation } from "react-router-dom";

interface HeaderState {
  remainCount: number
  subscription: Subscription | undefined
  card: StripeCard | undefined
  clientSecret: string | undefined
  isLoggedIn: boolean
  account: Account | undefined
  profileImage: ProfileImage | undefined
  screenWidth: number
  mobileSettingsVisible: boolean
  processingDialogVisible: boolean
  headerHidden: boolean
  
  setRemainCount: (by: number) => void
  setSubscription: (by: Subscription | undefined) => void
  setCard: (by: StripeCard | undefined) => void
  setClientSecret: (by: string) => void
  setIsLoggedIn: (by: boolean) => void
  setAccount: (by: Account | undefined) => void
  setScreenWidth: (by: number) => void
  setProfileImage: (by: ProfileImage | undefined) => void
  setMobileSettingsVisible: (by: boolean) => void
  setProcessingDialogVisible: (by: boolean) => void
  setHeaderHidden: (by: boolean) => void
  fetchCard: () => Promise<void>
  fetchRemainCount: () => Promise<void>
  fetchActiveSubscription: () => Promise<void>
  // fetchClientSecret: () => Promise<void>
  fetchAccount: () => Promise<void>
  fetchProfileImage: () => Promise<void>
  onLogin?: () => void;
}

export const useHeaderStore = create<HeaderState>()((set) => ({
  remainCount: 0,
  subscription: undefined,
  card: undefined,
  clientSecret: undefined,
  isLoggedIn: isLoggedIn(),
  account: undefined,
  screenWidth: window.innerWidth,
  profileImage: undefined,
  mobileSettingsVisible: false,
  processingDialogVisible: false,
  headerHidden: false,
  
  setClientSecret: (by) => set((state) => ({ clientSecret: by })),
  setIsLoggedIn: (by) => set((state) => ({ isLoggedIn: by })),
  setRemainCount: (by) => set((state) => ({ remainCount: by })),
  setSubscription: (by) => set((state) => ({ subscription: by })),
  setCard: (by) => set((state) => ({ card: by })),
  setAccount: (by) => set((state) => ({ account: by })),
  setProfileImage: (by) => set((state) => ({ profileImage: by })),
  setMobileSettingsVisible: (by) => set((state) => ({ mobileSettingsVisible: by })),
  setProcessingDialogVisible: (by) => set((state) => ({ processingDialogVisible: by })),
  setHeaderHidden: (by) => set((state) => ({ headerHidden: by })),

  fetchCard: async () => {
    if (!isLoggedIn()) return;
    const response = await fetchAsync<StripeCard[]>('Stripe/GetActiveCard');
    if(response.length >= 1) {
      set((state) => ({ card: response[0] }));
    }
  },
  fetchRemainCount: async () => {
    if (!isLoggedIn()) return;
    const response = await fetchAsync<RemainCountResponse>('Generation/GetRemainCount');
    set((state) => ({ remainCount: response.remainCount }));
  },
  fetchActiveSubscription: async () => {
    try {
      if (!isLoggedIn()) return;
      console.log('[fetchActiveSubscription] called');
      const response = await fetchAsync<Subscription>('Subscription/GetActiveSubscription');
      console.log('[fetchActiveSubscription] response', response);
      set((state) => ({ subscription: response }));
    } catch (e) {
      console.log('[fetchActiveSubscription] error', e);
      throw e;
    }
  },
  /*
  fetchClientSecret: async () => {
    const response = await fetchAsync<SetupIntentResponse>('Stripe/GetSetupIntent');
    set((state) => ({ clientSecret: response.clientSecret }));
  },*/
  fetchAccount: async () => {
    if (!isLoggedIn()) return;
    const response = await fetchAsync<Account>('Account/GetAccountInfo');
    set((state) => ({ account: response }));
  },
  fetchProfileImage: async () => {
    if (!isLoggedIn()) return;
    const response = await fetchAsync<ProfileImage>('Account/GetProfileImage');
    set((state) => ({ profileImage: response }));
  },
  setScreenWidth: (by) => set((state) => ({ screenWidth: by })),
}))

export const CommonHeader: FC = (props) => {
  // const [loginFlag, setLoginFlag] = useState(props.isLoggedIn);
  const [loginDialogVisible, setLoginDialogVisible] = useState(false);
  const {
    isLoggedIn, setIsLoggedIn,
    remainCount, setRemainCount,
    subscription, setSubscription,
    card, setCard,
    account, setAccount,
    screenWidth, setScreenWidth,
    onLogin,
    profileImage, setProfileImage,
    mobileSettingsVisible,
    processingDialogVisible,
    headerHidden, setHeaderHidden,
    fetchCard, fetchRemainCount, fetchActiveSubscription, fetchAccount, fetchProfileImage,
  } = useHeaderStore();

  useEffect(() => {
    if (isLoggedIn) {
      fetchRemainCount();
      fetchActiveSubscription();
      fetchCard();
      fetchAccount();
      fetchCard();
      fetchProfileImage();
      setScreenWidth(window.innerWidth);
    }
  }, [])
  
  async function onLoginEvent() {
     window.location.reload();
  }

  const [opened, { toggle }] = useDisclosure(false);
  const [loginDialogOpened, { open: openLoginDialog, close: closeLoginDialog }] = useDisclosure(false);
  const [spMenuDialogOpened, { open: openSpMenuDialog, close: closeSpMenuDialog }] = useDisclosure(false);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [generationCreditDialogProps, setGenerationCreditDialogProps] = useState<GenerationCreditDialogProps | undefined>(undefined);
  const [subscriptionDialogOpened, { open: openSubscriptionDialog, close: closeSubscriptionDialog }] = useDisclosure(false);
  const [subscriptionDialogProps, setSubscriptionDialogProps] = useState<SubscriptionDialogProps | undefined>(undefined);
  const [creditDialogOpened, { open: openCreditDialog, close: closeCreditDialog }] = useDisclosure(false);
  const [cardProps, setCardProps] = useState<CardRegistrationDialogProps | undefined>(undefined);

  async function toggleSpMenuDialog() {
    toggle();
    if (spMenuDialogOpened) {
      closeSpMenuDialog();
    } else {
      // メニューを開くたびに最新のプラン情報を取得
      try {
        if (isLoggedIn) {
          console.log('[HeaderMenuRefresh] open hamburger -> fetchActiveSubscription');
          await fetchActiveSubscription();
        }
      } catch (e) {
        console.log('[HeaderMenuRefresh] refresh error', e);
      }
      openSpMenuDialog();
    }
  }

  function onCloseSpMenuDialog() {
    closeSpMenuDialog();
    toggle();
  }

  function buildMenu(text: string, link: string, icon?: string){
    return (
      <a href={link}>
        <div className="flex items-center mt-5 ml-2">
          {icon && <img className="h-[20px] mr-2" src={icon}></img>}
          <span style={{color: '#03034F'}}>{text}</span>
        </div>
      </a>
    )
  }

  function logout() {
    removeToken();
    window.location.href = '/image-generation'
  }

  function redirectToImageGeneration() {
    if (window.location.pathname === '/image-generation') {
      return true;
    }
    window.location.href = '/image-generation?openSignup=1';
    return false;
  }

  function onClickSignupLink(){
    if (!redirectToImageGeneration()) {
      return;
    }
    setIsLoginMode(false);
    if (spMenuDialogOpened) {
      closeSpMenuDialog();
    }
    openLoginDialog();
    if (opened) {
      toggle();
    }
  }

  function onClickLoginLink(){
    setIsLoginMode(true);
    if (spMenuDialogOpened) {
      closeSpMenuDialog();
    }
    openLoginDialog();
    if (opened) {
      toggle();
    }
  }
  
  function onClickUpgradePlan() {
    const nextPlanId = getNextPlanId(subscription);
    setSubscriptionDialogProps({
      planId: nextPlanId
    } as SubscriptionDialogProps);
    openSubscriptionDialog();
  }

  function onClickCreditPurchase(){
    setGenerationCreditDialogProps({
      onPurchase: () => {
        toast.success("購入しました");
        setGenerationCreditDialogProps(undefined);
      }
    } as GenerationCreditDialogProps);
    openCreditDialog();
  }


  const location = useLocation();
  const showMobileSignupCta = !isLoggedIn;
  const hideDesktopTextNav =
    location.pathname.startsWith('/image-generation') ||
    location.pathname.startsWith('/video-generation') ||
    location.pathname.startsWith('/inspiration') ||
    location.pathname.startsWith('/account') ||
    location.pathname.startsWith('/subscription');

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setScreenWidth]);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      const current = window.scrollY;

      const isImageGenerationMobile =
        (location.pathname === '/image-generation' || location.pathname === '/video-generation') &&
        screenWidth < 640;

      if (screenWidth >= 640) {
        if (headerHidden) {
          setHeaderHidden(false);
        }
        lastScrollY = current;
        return;
      }

      if (isImageGenerationMobile) {
        const shouldHide = current > 0;
        if (shouldHide !== headerHidden) {
          setHeaderHidden(shouldHide);
        }
        lastScrollY = current;
        return;
      }

      if (current > lastScrollY + 5 && current > 0) {
        setHeaderHidden(true);
      } else if (current < lastScrollY - 5) {
        setHeaderHidden(false);
      }
      lastScrollY = current;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [screenWidth, headerHidden, setHeaderHidden, location.pathname]);

  useEffect(() => {
    if (location.pathname !== '/image-generation') {
      return;
    }

    const params = new URLSearchParams(location.search);
    if (params.get('openSignup') === '1') {
      setIsLoginMode(false);
      openLoginDialog();

      if (typeof window !== 'undefined') {
        params.delete('openSignup');
        const search = params.toString();
        const nextUrl = `${location.pathname}${search ? `?${search}` : ''}${location.hash ?? ''}`;
        window.history.replaceState(null, '', nextUrl);
      }
    }
  }, [location, openLoginDialog, setIsLoginMode]);

  return (
    <>
    <Toaster />
    <Modal size="auto" opened={loginDialogOpened} onClose={closeLoginDialog} yOffset="15dvh">
      <LoginDialog onCancel={() => setLoginDialogVisible(false)} onLogin={() => onLogin === undefined ? onLoginEvent() : onLogin() } isLogin={isLoginMode} />
    </Modal>

    { cardProps !== undefined &&
    <CardRegistrationDialog clientSecret={cardProps?.clientSecret!} onClose={() => setCardProps(undefined)} />
    }

    { generationCreditDialogProps !== undefined &&
    <Modal padding={0} size="auto" opened={creditDialogOpened} onClose={closeCreditDialog} closeButtonProps={{ className: 'mr-3' }}>
      <GenerationCreditDialog
        onPurchase={() => setGenerationCreditDialogProps(undefined)}
        onCancel={() => setGenerationCreditDialogProps(undefined)}
        onUpgrade={onClickUpgradePlan}
        />
    </Modal>
    }

    { subscriptionDialogProps !== undefined &&
    <Modal size="auto" opened={subscriptionDialogOpened} onClose={closeSubscriptionDialog}>
      <SubscriptionDialog onPurchase={() => setSubscriptionDialogProps(undefined)} onCancel={() => setSubscriptionDialogProps(undefined)} planId={subscriptionDialogProps?.planId} />
    </Modal>
    }
  

    <Modal fullScreen size="auto" opened={spMenuDialogOpened} onClose={() => onCloseSpMenuDialog()}>
      <img className="mr-2 absolute w-[100px] left-[20px] top-[16px]" style={{ zIndex: 1000}} src="/images/drop-ai-logo.png"></img>
      { !isLoggedIn &&
      <div className="gradient-border mt-2">
        <div className="flex justify-between items-center gradient-content" onClick={onClickSignupLink}>
          <div className="ml-3 py-2">
            <div className="text-sm text-gray-500">DROP AIを体験してみましょう</div>
            <div className="gradation-text font-bold text-lg">無料アカウント登録</div>
          </div>
          <div>
            <img src="/images/icon/icon-right.svg" className="h-[20px] mr-2"></img>
          </div>
        </div>
        </div>
      }
      { !isLoggedIn &&
      <div className="mt-4 rounded flex items-center py-2 pl-2 justify-between bg-[#EAEAFF] clickable" onClick={onClickLoginLink}>
        <span className="flex items-center">
          <img className="h-[20px] mr-2" src="/images/icon/icon-user.svg"></img>
          <span>ログインする</span>
        </span>
        <img className="h-[20px] mr-2" src="/images/icon/icon-right.svg"></img>
      </div>
      }
      { isLoggedIn &&
        <>
        <div className="flex mb-4 mt-2 ml-2 items-center">
            <img src="/images/icon/no-image.svg" className="h-[30px] w-[30px] mr-2" />
            <span className="text-sm text-gray-500">{account?.email}</span>
        </div>
        <div className="flex">
          <div className="mb-4 w-[50%] justify-between items-center text-sm border rounded-lg p-2">
            <div className="text-xs text-gray-500">現在のプラン</div>
            <div className="font-bold">{getPlanNameBySubscription(subscription)}</div>
            { (subscription?.internalProductId === 'free' || subscription?.internalProductId.startsWith('lite') || subscription?.internalProductId.startsWith('standard')) &&
            <div onClick={onClickUpgradePlan} className="text-xs clickable font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#0000F3] to-[#F416BF]">プランをアップグレード</div>
            }
          </div>

          <div className="mb-4 ml-2 w-[50%] justify-between items-center text-sm border rounded-lg p-2">
            <div>
              <div className="text-xs text-gray-500">現在のクレジット</div>
              <div className="flex items-center">
                <img src="/images/icon/icons8-lightning.png" className="h-[20px] mr-2" />
                <span className="font-bold mr-1">{remainCount}</span>
                
              </div>
            </div>
            { (subscription?.internalProductId === 'lite' || subscription?.internalProductId.startsWith('standard') || subscription?.internalProductId.startsWith('advanced')) &&  
            <div className="clickable" onClick={onClickCreditPurchase}>クレジットを追加 +</div>
            }
          </div>
        </div>
        <div className="bg-gray-300 h-[1px] w-full mt-4"></div>
        <a href="/image-generation">
          <div className="flex items-center mt-4 ml-2">
            <img className="h-[20px] mr-2" src="/images/icon/icon-flare-color.svg"></img>
            <span className="text-lg gradation-text font-bold">画像生成</span>
          </div>
        </a>
        <a href="/video-generation">
          <div className="flex items-center mt-4 ml-2">
            <img className="h-[20px] mr-2" src="/images/icon/icon-flare-color.svg"></img>
            <span style={{color: '#03034F'}}>動画生成</span>
          </div>
        </a>
        { buildMenu("インスピレーション", "/inspiration", "/images/icon/icons8-gallery-512.png") }
        { buildMenu("生成履歴", "/generation-history", "/images/icon/icons8-gallery-480.png") }
        { buildMenu("アカウント", "/account", "/images/icon/icons8-male-user-512.png") }
        </>
      }
      { buildMenu("料金プラン", "/plan", "/images/icon/icons8-wallet-500.png") }
      
      
      {/* SkyFlag banner (show only when logged in) */}
      { isLoggedIn && (
        <div className="mt-6 px-4">
          <a href={`${getSkyFlagUrl()}`} target="_blank" onClick={() => {
            const url = getSkyFlagUrl();
            console.log('[AppBanner] Click (header menu):', url);
          }}>
            <img src="/images/skyflag-banner2.png" className="w-full rounded-lg" />
          </a>
        </div>
      )}
      
      <div style={{ height: 20 }}></div>
      <div className=" w-full text-gray-500">
        <div className="flex">
          <a className="text-sm mr-4" href="/article/help">ヘルプ</a>
          <a className="text-sm mr-4" href="/terms-of-service">利用規約</a>
          <a className="text-sm" href="/privacy-policy">プライバシーポリシー</a>
        </div>
        <div className="text-sm mt-4 mb-6 text-gray-500">
          <span className="clickable" onClick={logout}>ログアウト</span>
        </div>
        <div className="bg-gray-300 h-[1px] w-full mt-4"></div>
        <div className="text-sm mt-2 mb-4 text-gray-500">
          GO TO MARKET, inc. All Rights. Reserved.
        </div>
      </div>
    </Modal>
  
    {!mobileSettingsVisible && !processingDialogVisible && (
    <header className={`${classes.header} ${headerHidden ? classes.headerHidden : ''}`}>
      <Container size="md" className={classes.inner}>
        <a href={ window.location.pathname === '/' ? '/' : '/image-generation'}>
          <img src="/images/drop-ai-logo.png" className="h-[30px] ml-4 pr-2"></img>
        </a>
        {!hideDesktopTextNav && (
          <Group gap={28} visibleFrom="xs" className="ml-auto mr-4">
            <a className="text-[#03034F] text-sm font-medium" href="/">サイトTOP</a>
            <a className="text-[#03034F] text-sm font-medium" href="/image-generation">画像生成</a>
            <a className="text-[#03034F] text-sm font-medium" href="/video-generation">動画生成</a>
            <a className="text-[#03034F] text-sm font-medium" href="/inspiration">インスピレーション</a>
            <a className="text-[#03034F] text-sm font-medium" href="/plan">プラン</a>
            <a className="text-[#03034F] text-sm font-medium" href="/article/help">ヘルプ</a>
          </Group>
        )}
        <Group gap={5} visibleFrom="xs">
          { isLoggedIn === true &&
            <a href="/account">
             <div className="flex rounded-md border border-gray-300 py-1 px-2 items-center">
              <img src={getProfileImageUrl(profileImage)} className="h-[30px] w-[30px] mr-2 rounded-full"/>
              <div className="ml-2">
                <div className="text-sm font-bold">{getPlanNameBySubscription(subscription)}プラン</div>
                <div className="text-sm text-gray-500 flex items-center">
                  <img
                    src="/images/icon/icons8-lightning.png"
                    alt="アイコン"
                    className="h-4 w-4 mr-1"
                  />
                  <span className="w-[40px] inline-block">{remainCount}</span>
                </div>
              </div>
             </div>
            </a>
          }
          { isLoggedIn === false &&
          <>
            <button 
              onClick={onClickLoginLink} 
              className="ml-2 login-button-no-border px-4 py-1.5 rounded-md">
              <span className="gradation-text text-[14px]">ログイン</span>
            </button>
            <button
              type="button"
              onClick={onClickSignupLink}
              className="gradation-border-button ml-2 px-4 py-1.5 rounded-md hover:scale-105 transition-all duration-200"
              style={{ borderRadius: '4px' }}
            >
              <span className="gradation-text text-[14px] font-bold">無料で アカウント登録</span>
            </button>
          </>
          }
        </Group>

        <div className={classes.mobileCta}>
          {showMobileSignupCta && (
            <button
              type="button"
              onClick={onClickSignupLink}
              className={`gradation-border-button ${classes.mobileCtaButton}`}
              style={{ borderRadius: '4px' }}
            >
              <span className="gradation-text">無料アカウント登録</span>
            </button>
          )}
          <Burger opened={opened} onClick={toggleSpMenuDialog} hiddenFrom="xs" size="sm" />
        </div>
        
      </Container>
    </header>
    )}
    </>
  );

}
